import React from 'react';
import './App.scss';
import { AuthProvider } from './contexts/AuthContext';
import RouterSetup from './pages/RouterSetup';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesProvider';
import { ToastProvider } from './contexts/ToastContext';
import { RefreshProvider } from './contexts/RefreshContext';

function App() {
  return (
    <AuthProvider>
      <UnsavedChangesProvider>
        <RefreshProvider>
          <ToastProvider>
            <RouterSetup />
          </ToastProvider>
        </RefreshProvider>
      </UnsavedChangesProvider>
    </AuthProvider>
  );
}

export default App;
